function unavailable() { return null; }
export const GitSyncDialog = unavailable;